import { Typography } from "../../molecules/Typography";
import { useUserStore } from "../../../../modules/Auth/stores/authStore";

export default function Challenge60DaysLock() {
  const loggedUser = useUserStore((state) => state.user);

  const modulesGranted = loggedUser?.permissions?.modulesGranted || [];

  if(
    modulesGranted.length === 0 ||
    !modulesGranted.includes('navegacao-livre-disciplinas')
  ) {
    return <iframe
      src='https://aprovatotal.com.br/desafio-60-dias-combo'
      className='h-[calc(100vh-134px)] w-full lg:h-[calc(100vh-64px)]'
    />
  }

  if(modulesGranted.includes('aprova-live')) {
    return (
      <div className='w-full h-[30vh] flex items-center justify-center'>
        <div className='w-[80%] bg-mono-color-white rounded-md shadow-level-2 p-8'>
          <Typography type="title" size="h3" className='text-center'> 
            Se você é aluno do AprovaLive, já têm acesso ao Desafio 60 Dias!
          </Typography>
        </div>
      </div>
    )
  }
  
  return (
    <iframe
      src='https://aprovatotal.com.br/desafio-60-dias-alunos/'
      className='h-[calc(100vh-134px)] w-full lg:h-[calc(100vh-64px)]'
    />
  );
}
